import { FC, memo, useEffect, useState } from 'react';
import styles from './index.less';
import { repairStatusMap } from '@/pages/RepairManage/config';
import type { RepairDetailItemType } from '@/pages/RepairManage/config';
import { Button, Cell, Flex, Image } from 'react-vant';
import BindFee from '../BindFee';
import { ugentTypeList } from '@/pages/RepairContent/config';
import { useNavigate } from '@umijs/max';

interface DetailProps {
  detailItems?: Partial<RepairDetailItemType>;
  /**重发*/
  refreshSendClick: () => void;
  /**编辑*/
  editClick: (id: string) => void;
  /**撤销*/
  cancelClick: () => void;
}



const Detail: FC<DetailProps> = ({
  detailItems,
  refreshSendClick,
  editClick,
  cancelClick,
}) => {

  const navigate = useNavigate();

const goBack = () => {
  navigate(-1); // 返回上一级
};
  const [imgList, setImgList] = useState<Array<any>>([]);
  const [bindVisible, setBindVisible] = useState<boolean>(false);


  useEffect(() => {
    setImgList((detailItems?.image && detailItems?.image.split(',')) || []);

    console.log('sequenceNbr', detailItems?.sequenceNbr)
  }, [detailItems]);

  const formatUrgent = (data: any) => {
    return data ? ugentTypeList.find((item: any )=> item.value === data)?.text : ''
  }

  const view = () => {
    setBindVisible(true)
  }

  const closeFee = (isSuccess?: boolean) => {
    setBindVisible(false)
    if(isSuccess) {
      goBack()
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.container}>
      <div
        className={styles.tag}
        style={{
          backgroundColor:
            detailItems &&
            detailItems.ticketStatus &&
            repairStatusMap[detailItems.ticketStatus!]?.backGroundColor,
          color:
            detailItems &&
            repairStatusMap[detailItems.ticketStatus!]?.textColor,
        }}
      >
        <img
          src={
            detailItems &&
            detailItems.ticketStatus &&
            repairStatusMap[detailItems.ticketStatus!].icon
          }
          alt={'icon'}
        />
        <span>
          {detailItems &&
            detailItems.ticketStatus &&
            repairStatusMap[detailItems.ticketStatus!].text}
        </span>
      </div>
      <div className={styles.content}>
        <Cell.Group>
          <Cell title="工单号" value={detailItems?.ticketNo} />
          <Cell title="上报人" value={detailItems?.reporter} />
          <Cell title="联系电话" value={detailItems?.reporterPhone} />
          <Cell title="报事位置" value={detailItems?.position} />
          <Cell title="位置描述" value={detailItems?.positionDesc} />
          <Cell title="事件一级分类" value={detailItems?.firstCategoryName} />
          <Cell title="事件二级分类" value={detailItems?.secondCategoryName} />
          <Cell title="紧急度" value={formatUrgent(detailItems?.urgent)} />
          <Cell title="事件描述" value={detailItems?.ticketContent} />
          {/* <Cell title="查看流转记录" isLink onClick={viewProcess} /> */}
        </Cell.Group>
        <div className={styles['images']}>
          <Flex wrap="wrap" gutter={3}>
            {imgList?.map((image, index) => (
              <Flex.Item>
              <Image
                lazyload
                height="100"
                key={index}
                width="100px"
                src={image}
              />
              </Flex.Item>
            ))}
          </Flex>
        </div>
      </div>

      {!!detailItems?.recordFeeList?.length && !detailItems?.confirmFee && (
        <div className={styles['default-btn']}>
          <div onClick={view}>
            <Button type="info" round size="small">
              确认有偿服务数据
            </Button>
          </div>
        </div>
      )}

     <BindFee  visible={bindVisible} sequenceNbr={detailItems?.sequenceNbr} paidAmount={detailItems?.paidAmount} recordFeeList={detailItems?.recordFeeList || []} close={closeFee}/>
    </div>
    </div>
  );
};

export default memo(Detail);
